import { FIREBASE_STORAGE_KEYS } from '../utils/constantsNumberLogin';

const MINUTES_TO_MILLISECONDS = 60 * 1000;

/**
 * Check remaining wait time before retry is allowed
 * @returns {number} Wait time in minutes or 0 if no limit
 */
export const getRemainingWaitTime = () => {
  const retryAfter = localStorage.getItem(FIREBASE_STORAGE_KEYS.RETRY_AFTER);
  if (!retryAfter) return 0;
  
  const waitUntil = parseInt(retryAfter);
  const now = Date.now();
  
  if (now < waitUntil) {
    return Math.ceil((waitUntil - now) / MINUTES_TO_MILLISECONDS);
  } else {
    localStorage.removeItem(FIREBASE_STORAGE_KEYS.RETRY_AFTER);
    return 0;
  }
};

/**
 * Set wait time period for connection attempts
 * @param {number} minutes - Number of minutes to wait
 */
export const setRateLimitWaitTime = (minutes) => {
  const waitUntil = Date.now() + (minutes * MINUTES_TO_MILLISECONDS);
  localStorage.setItem(FIREBASE_STORAGE_KEYS.RETRY_AFTER, waitUntil.toString());
};

/**
 * Clear current rate limit
 */
export const clearRateLimit = () => {
  localStorage.removeItem(FIREBASE_STORAGE_KEYS.RETRY_AFTER);
}; 